import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ReactDOMServer from 'react-dom/server';
import * as Fi from 'react-icons/fi';
import jsPDF from 'jspdf';
import cn from 'classnames';
import _ from 'underscore';

import logoBlack from 'ui/assets/envio-black.png';
import { Client } from 'services/action';
import { currencyFormat, formatDate } from 'utilities/common';

let doc = new jsPDF('p', 'pt', 'a4');

const PDFInvoice = ({ data }) => {
  const Dispatch = useDispatch();
  const StateClient = useSelector((state) => state?.Auth?.session?.client);

  const [loading, setLoading] = React.useState(false);
  const [client, setClient] = React.useState(false);
  const [page, setPage] = React.useState(null);
  const [firstPage] = React.useState(16);
  const [limit] = React.useState(16);
  const [tcv, setTcv] = React.useState(0);

  const save = () => {
    setLoading(true);

    doc.html(ReactDOMServer.renderToStaticMarkup(shipment), {
      callback: () => {
        // last page hapus aja ya okeh :)
        doc.deletePage(doc.internal.getNumberOfPages());
        doc.save(`INV-${data?.code}.pdf`);
        doc = new jsPDF('p', 'pt', 'a4');
        setLoading(false);
      },
    });
  };

  React.useEffect(() => {
    const $onLoad = async (id) => {
      const req = await Dispatch(Client.$show(id));
      if (req?.message === 'success') {
        setClient(req?.data);
      }
    };

    $onLoad(StateClient?.id);
  }, []);

  React.useEffect(() => {
    if (client === null) {
      return;
    }

    if (data) {
      let pages = _.chunk(data?.delivery_orders, firstPage);
      if (data?.delivery_orders?.length > firstPage) {
        let first = pages[0];
        let last = _.rest(data?.delivery_orders, first?.length);
        pages = _.chunk(last, limit);
        pages.unshift(first);
      } else {
        setPage(pages);
      }

      let tcv = 0;
      _.each(data?.delivery_orders, function (i) {
        tcv += i?.shipment?.cod_value;
      });

      setTcv(tcv);
      setPage(pages);
    }
  }, [data, client]);

  if (!data) return null;

  const shipment = (
    <>
      <section
        className="pdf-sheet"
        style={{ paddingLeft: '20px', paddingRight: '20px' }}
      >
        <div className="row justify-content-center align-items-center">
          <div className="col-4">
            <h1 style={{ fontWeight: 800, fontSize: 30 }}>INVOICE</h1>
            <h2 className="pdf-title text-uppercase">
              {client?.company_name || client?.name}
            </h2>
            <p className="pdf-text text-capitalize" style={{ fontSize: 7 }}>
              {client?.address}
            </p>
          </div>

          <div className="col-8 text-end">
            <img
              src={client?.avatar?.replace('_thumb', '') || logoBlack}
              alt=""
              style={{ maxHeight: 50, maxWidth: '100%' }}
            />
          </div>
        </div>

        <div className="mt-3" style={{ marginLeft: 3 }}>
          <div className="row">
            <div className="col-4 p-1">
              <div>
                <h4 className="pdf-head">Kepada: </h4>
                <p className="pdf-text text-uppercase">
                  {data?.customer?.company_name || data?.customer?.name}
                </p>
                <p className="pdf-text text-capitalize" style={{ fontSize: 7 }}>
                  {data?.customer?.address || '-'}
                </p>
              </div>
            </div>
            <div className="col-3" />
            <div className="col-5 p-1">
              <div className="d-flex justify-content-between align-items-center">
                <h4 className="pdf-head">INVOICE #</h4>
                <p className="pdf-text text-end">{data?.code}</p>
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <h4 className="pdf-head">INVOICE DATE</h4>
                <p className="pdf-text text-end">
                  {formatDate(new Date(), 'DD/MM/YYYY')}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className=" mt-3" style={{ marginLeft: 3 }}>
          <div className="row bg-primary">
            <div className="col-1 text-start py-2">
              <p className="fw-bold pdf-text text-white">No</p>
            </div>
            <div className="col-4 text-start py-2">
              <p className="fw-bold pdf-text text-white">Jenis Pengiriman</p>
            </div>
            <div className="col-3 text-center py-2">
              <p className="fw-bold pdf-text text-white">Jumlah Pengiriman</p>
            </div>
            <div className="col-4 text-end py-2">
              <p className="fw-bold pdf-text text-white">Total Biaya</p>
            </div>
          </div>
          <div className="row bg-white border-bottom">
            <div className="col-1 text-start py-2">
              <p className="pdf-text text-secondary">1.</p>
            </div>
            <div className="col-4 text-start py-2">
              <p className="pdf-text mb-0 fw-bold text-capitalize">
                {data?.service_type?.name}
              </p>
              <p className="pdf-subtitle mb-0 text-capitalize">
                {data?.service_type?.service?.name}
              </p>
            </div>
            <div className="col-3 text-center py-2">
              <p className="pdf-text text-secondary">
                {data?.shipment_count?.total}
              </p>
            </div>
            <div className="col-4 text-end py-2">
              <p className="pdf-text text-secondary">
                {currencyFormat(data?.total_charges)}
              </p>
            </div>
          </div>
          <div>
            {data?.total_payments > 0 && (
              <div className="row bg-white">
                <div className="col-4 py-2 offset-8">
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="pdf-text  text-secondary">Telah dibayar</p>
                    <p className="pdf-text fw-bold text-secondary">
                      {currencyFormat(data?.total_payments, 'IDR')}
                    </p>
                  </div>
                </div>
              </div>
            )}
            <div className="row bg-white">
              <div className="col-4 py-2 offset-8">
                <div className="d-flex justify-content-between align-items-center">
                  <p className="pdf-text  text-secondary">Total COD</p>
                  <p className="pdf-text fw-bold text-secondary">
                    {currencyFormat(tcv, 'IDR')}
                  </p>
                </div>
              </div>
            </div>
            <div className="row bg-white">
              <div className="col-4 py-2 offset-8">
                <div className="d-flex justify-content-between align-items-center">
                  <p className="pdf-text  text-secondary">Total Penagihan</p>
                  <p className="pdf-text fw-bold text-secondary">
                    {currencyFormat(data?.total_charges, 'IDR')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-3">
          <div className="row bg-white">
            <div className="col-8 text-start py-2">
              <p className="pdf-text text-secondary">Informasi Pembayaran</p>
              <p className="pdf-text fw-bold text-secondary">Transfer via:</p>
              <p className="pdf-text text-secondary">{client?.bank_account}</p>
            </div>
            <div className="col-4 text-start py-2">
              <div className="text-center">
                <p className="pdf-text text-secondary pb-3">Regards</p>
                <p className="pdf-subtitle text-secondary pt-4 text-decoration-underline">
                  Nama/ TTD/ Stempel
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {page?.map((p, id) => (
        <section
          className="pdf-sheet mt-3 mb-0"
          style={{ paddingLeft: '20px', paddingRight: '20px' }}
          key={id}
        >
          <div className="row bg-primary" style={{ marginLeft: 3 }}>
            <div className="col-1 text-start py-2 pe-0">
              <p className="fw-bold pdf-text text-white">No</p>
            </div>
            <div className="col-2 text-start py-2 ps-0">
              <p className="fw-bold pdf-text text-white">Kode Shipment</p>
            </div>

            <div className="col-2 text-start py-2">
              <p className="fw-bold pdf-text text-white">
                {data?.type === 'ftl' ? 'Pickup' : 'Pengirim'}
              </p>
            </div>
            <div className="col-2 text-start py-2">
              <p className="fw-bold pdf-text text-white">
                {data?.type === 'ftl' ? 'Drop Point' : 'Penerima'}
              </p>
            </div>
            <div className="col-2 text-end py-2">
              <p className="fw-bold pdf-text text-white">COD</p>
            </div>
            <div className="col-2 text-end py-2">
              <p className="fw-bold pdf-text text-white">Harga</p>
            </div>
            <div className="col-1 text-center py-2">
              <p className="fw-bold pdf-text text-white">Status</p>
            </div>
          </div>

          {p?.map((d, i) => (
            <div
              className="row bg-white border-bottom"
              key={i}
              style={{ marginLeft: 3 }}
            >
              <div className="col-1 text-start py-2 pe-0">
                <p className="pdf-text text-secondary">
                  {id > 1
                    ? limit + (firstPage * (id - 1) + i + 1)
                    : firstPage * id + i + 1}
                </p>
              </div>
              <div className="col-2 text-start py-2 ps-0">
                <p className="pdf-text mb-0 fw-bold">{d?.shipment?.code}</p>
                <p className="pdf-text text-secondary" style={{ fontSize: 7 }}>
                  {formatDate(d?.shipment?.atd_at, 'DD/MM/YYYY')}
                </p>
              </div>

              <div className="col-2 text-start py-2">
                {data?.type === 'ftl' ? (
                  <>
                    <p className="pdf-text text-secondary text-capitalize">
                      {d?.shipment?.origin?.name}
                    </p>
                    <p
                      className="pdf-subtitle text-secondary text-capitalize"
                      style={{ fontSize: 7 }}
                    >
                      Shipper: {d?.shipment?.shipper?.name}
                    </p>
                  </>
                ) : (
                  <p className="pdf-text text-secondary text-capitalize">
                    {d?.shipment?.shipper?.name}
                  </p>
                )}
              </div>
              <div className="col-2 text-start py-2">
                <p className="pdf-text text-secondary text-capitalize">
                  {d?.shipment?.destination?.name}
                </p>
              </div>
              <div className="col-2 text-end py-2">
                <p className="pdf-text text-secondary">
                  {currencyFormat(d?.shipment?.cod_value, 'IDR')}
                </p>
              </div>
              <div className="col-2 text-end py-2">
                <p className="pdf-text text-secondary">
                  {currencyFormat(d?.total_charges, 'IDR')}
                </p>
              </div>
              <div className="col-1 text-center py-2">
                <p
                  className={`pdf-text text-uppercase ${
                    d?.document_status === 'delivered'
                      ? 'text-success'
                      : 'text-danger'
                  }`}
                >
                  {d?.document_status}
                </p>
              </div>
            </div>
          ))}
        </section>
      ))}
    </>
  );

  return (
    <div
      className={cn(
        'dropdown-item d-flex align-items-center cursor-pointer border-bottom'
      )}
      onClick={loading ? null : save}
    >
      {loading ? (
        <div className="spinner-border text-primary" role="status"></div>
      ) : (
        <>
          <Fi.FiDownload size={15} color="#202020" className="me-2" />
          Download Invoice
        </>
      )}
    </div>
  );
};

export default PDFInvoice;
